import { render } from "./bank_add.vue?vue&type=template&id=0600c408"
import script from "./bank_add.vue?vue&type=script&lang=js"
export * from "./bank_add.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__